// type RequisitTypeModel = 1 | 100 | 200

export enum PaymentRequisiteToType {
  SbpPhoneNumber = 1,
  CardNumber = 100,
  AccountNumber = 200,
  SbpPaymentLink = 300,
}
export enum PaymentRequisiteToStatus {
  Unknown = 0,
  Active = 1,
  AwaitingVerification = 10,
  Blocked = 20,
  Deleted = 30,
  Disabled = 40,
}
export type PaymentRequisiteModel = {
  id: string
  value: string
  requisitType: PaymentRequisiteToType
  currency: number
  requisitId: string
  userId: string
  isVerified: boolean
  verifiedAt: string
  isBlocked: boolean
  blockedAt: string
  blockReason: string
  isDisabledByUser: boolean
  disabledAt: string
  isDeleted: boolean
  deletedAt: string
  lockedForPayment: boolean
  lockedAt: string,
  limits: LimitModel[],
}

export type PaymentRequisiteShortModel = {
  id: string
  value: string
  type: PaymentRequisiteToType
  status: PaymentRequisiteToStatus
  initiatedTopupsCounter: number
  successTopupCounter: number
}

export interface NewPaymentRequisiteModel {
  value: string
  requisitType: PaymentRequisiteToType
  requisitId: string
}

export interface LimitModel {
  id: string,
  maxPerDay: number,
  topupPaymentChannelId: string,
  paymentRequisitId: string,
  pendingCount: number,
  successCount: number,
}

export type RequisiteIconStatus = 'green' | 'grey' | 'red' | 'yellow' | 'none'
export const PaymentRequisiteStatusMap: Record<
  PaymentRequisiteToStatus,
  { title: string; color: RequisiteIconStatus }
> = {
  [PaymentRequisiteToStatus.Active]: {
    title: 'Активен',
    color: 'green',
  },
  [PaymentRequisiteToStatus.AwaitingVerification]: {
    title: 'Ожидание подтверждения',
    color: 'yellow',
  },
  [PaymentRequisiteToStatus.Blocked]: {
    title: 'Заблокирован',
    color: 'red',
  },
  [PaymentRequisiteToStatus.Deleted]: {
    title: 'Удален',
    color: 'red',
  },
  [PaymentRequisiteToStatus.Disabled]: {
    title: 'Отключен',
    color: 'grey',
  },
  [PaymentRequisiteToStatus.Unknown]: { title: 'Неизвестен', color: 'grey' },
}

export const PaymentRequisitNames: Record<PaymentRequisiteToType, string> = {
  [PaymentRequisiteToType.AccountNumber]: 'Номер счета',
  [PaymentRequisiteToType.CardNumber]: 'Номер карты',
  [PaymentRequisiteToType.SbpPhoneNumber]: 'Номер телефона',
  [PaymentRequisiteToType.SbpPaymentLink]: 'Озон чаевые',
}